import { render, staticRenderFns } from "./branch_gap_analysis.vue?vue&type=template&id=6b7030b9&scoped=true&"
import script from "./branch_gap_analysis.vue?vue&type=script&lang=js&"
export * from "./branch_gap_analysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7030b9",
  null
  
)

export default component.exports